import { HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, map, catchError, of } from 'rxjs'
import { WebService } from '../api/web.service'
import { CommonService } from './common.service'

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private webService: WebService, private cs: CommonService) {}

  downloadDocument(
    endPoint: string,
    options?: { queryParams?: Record<string, any>[]; requestBody?: any },
    expectedFileName?: string,
    headers?: HttpHeaders
  ): void {
    const { queryParams, requestBody } = options || {}
    let documentResponse$: Observable<any>

    if (options) {
      documentResponse$ = this.webService.downloadFilePOST(endPoint, queryParams, requestBody, headers)
    } else {
      documentResponse$ = this.webService.downloadFileGET(endPoint, headers)
    }

    documentResponse$
      .pipe(
        map(response => {
          const contentDispositionHeader: string | null = response.headers.get('content-disposition')
          const filenameMatches: RegExpMatchArray | null = contentDispositionHeader?.match(/filename=["'](.+?)["']/)
          const filename: string = filenameMatches?.[1] || expectedFileName || 'file.pdf'
          const blob: Blob = new Blob([response.body], { type: response.body.type })
          const a = document.createElement('a')
          a.download = filename
          a.href = window.URL.createObjectURL(blob)
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(a.href)
        }),
        catchError((error: any) => {
          this.cs.showError(`Unable to download document at this time`)
          return of(null)
        })
      )
      .subscribe()
  }
}
